import { useTranslation } from "react-i18next";
import { NeuButton } from "../../components/neu/Neu";

const ACTIONS = {
  quotation: {
    draft: ["send"],
    sent: ["accept", "reject"],
    accepted: ["convert"],
  },
  order: {
    draft: ["confirm"],
    confirmed: ["hold", "cancel"],
    on_hold: ["release", "cancel"],
    partially_delivered: [],
  },
  delivery: {
    draft: ["pick"],
    picked: ["ship"],
    shipped: ["deliver"],
  },
};

// أزرار الأفعال المسموحة فقط بحسب نوع المستند وحالته.
export const DocActions = ({ doc, onRun, busy }) => {
  const { t } = useTranslation();
  const actions = (ACTIONS[doc.doc_type] || {})[doc.state] || [];
  if (!actions.length) return null;

  return (
    <div className="flex flex-wrap gap-2" data-testid="doc-actions">
      {actions.map((action) => (
        <NeuButton
          key={action}
          variant={["send", "confirm", "convert", "deliver"].includes(action) ? "primary" : undefined}
          className="px-3 py-2 text-xs"
          data-testid={`doc-action-${action}`}
          disabled={busy}
          onClick={() => onRun(action)}
        >
          {t(`sales.actions.${action}`)}
        </NeuButton>
      ))}
    </div>
  );
};
